import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./assets/css/aos.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/media_query.css";
import "./assets/css/style.css";
import "./assets/css/swap.css";
import "./assets/css/swiper_bundle.min.css";
import AosAnimtion from "./component/AosAnimtion";
import BottomTopBtn from "./component/BottomTopBtn";
import Loader from "./component/Loader";
import About from "./pages/About.jsx";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import Blog3 from "./pages/Blog3";
import BlogDetails1 from "./pages/BlogDetails1";
import BlogDetails2 from "./pages/BlogDetails2";
import BlogDetails3 from "./pages/BlogDetails3";
import ComingSoon from "./pages/ComingSoon";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Project1 from "./pages/Project1";
import Project2 from "./pages/Project2";
import Project3 from "./pages/Project3";
import ProjectDetails1 from "./pages/ProjectDetails1";
import ProjectDetails2 from "./pages/ProjectDetails2";
import ProjectDetails3 from "./pages/ProjectDetails3";
import Services1 from "./pages/Services1";
import Services2 from "./pages/Services2";
import Services3 from "./pages/Services3";
import ServicesDetails1 from "./pages/ServicesDetails1";
import ServicesDetails2 from "./pages/ServicesDetails2";
import ServicesDetails3 from "./pages/ServicesDetails3";

function App() {
  return (
    <>
      {/* basename para rodar dentro da pasta /philippe na hospedagem */}
      <BrowserRouter basename="/">
        <Routes>
          {/* Home padrão */}
          <Route path="/" element={<Home />} />

          {/* Home acessando /philippe/index.html */}
          <Route path="/index.html" element={<Home />} />

          <Route path="about" element={<About />} />
          <Route path="faq" element={<Faq />} />
          <Route path="ComingSoon" element={<ComingSoon />} />
          <Route path="services1" element={<Services1 />} />
          <Route path="services2" element={<Services2 />} />
          <Route path="services3" element={<Services3 />} />
          <Route path="ServicesDetails1" element={<ServicesDetails1 />} />
          <Route path="ServicesDetails2" element={<ServicesDetails2 />} />
          <Route path="ServicesDetails3" element={<ServicesDetails3 />} />
          <Route path="Project1" element={<Project1 />} />
          <Route path="Project2" element={<Project2 />} />
          <Route path="Project3" element={<Project3 />} />
          <Route path="ProjectDetails1" element={<ProjectDetails1 />} />
          <Route path="ProjectDetails2" element={<ProjectDetails2 />} />
          <Route path="ProjectDetails3" element={<ProjectDetails3 />} />
          <Route path="Blog1" element={<Blog1 />} />
          <Route path="Blog2" element={<Blog2 />} />
          <Route path="Blog3" element={<Blog3 />} />
          <Route path="BlogDetails1" element={<BlogDetails1 />} />
          <Route path="BlogDetails2" element={<BlogDetails2 />} />
          <Route path="BlogDetails3" element={<BlogDetails3 />} />
          <Route path="Contact" element={<Contact />} />

          {/* Rota coringa – mantém seu 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

      <Loader />
      <AosAnimtion />
      <BottomTopBtn />
    </>
  );
}

export default App;
